import { useQuery } from '@tanstack/react-query'
import { Badge, Card, Skeleton } from '@indipia/ui-core'
import { orderApi } from '../../api/orderApi'
import { ORDER_MESSAGE } from '../../constants/materialOrder.logic'
import { ErrorBanner } from '../AsyncState'

// 알림톡 미리보기 — 서버 렌더 결과만 표시한다(본문·변수를 FE가 조립하지 않음, 지시서 E6).
// 조회가 실패하면 이 영역만 오류 상태로 표시하고 나머지 기능은 그대로 동작한다(조용히 숨기지 않음).

interface Props {
  orderVendorId: number
  /** 발주정보가 바뀌면(저장 완료로 contentVer 증가·상태 변화) 다시 조회하기 위한 값 */
  version: string | number
}

export function OrderNoticePreview({ orderVendorId, version }: Props) {
  const q = useQuery({
    queryKey: ['order-notice-preview', orderVendorId, version],
    queryFn: () => orderApi.getOrderNoticePreview(orderVendorId),
    staleTime: 0,
    retry: false,
  })

  return (
    <section aria-label={ORDER_MESSAGE.previewTitle} aria-busy={q.isFetching}>
      <div>
        {q.isLoading && <Skeleton height={64} />}
        {q.isError && <ErrorBanner message={ORDER_MESSAGE.previewFailed} onRetry={() => void q.refetch()} />}
        {q.data && (
          <Card>
            <p className="whitespace-pre-line text-body-sm text-text-primary">{q.data.content}</p>
            {q.data.buttons.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1">
                {q.data.buttons.map(b => <Badge key={b} status="info">{b}</Badge>)}
              </div>
            )}
          </Card>
        )}
      </div>
    </section>
  )
}
